<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        Videos
        <div class="page__header-subtitle">
          All workout videos available here
        </div>
      </div>
      <div class="page__header-tools">
        <b-row>
          <b-col>
            <b-form-input
              v-model="searchText"
              size="sm"
              placeholder="Find files here"
              @input="searchVideo($event)"
              trim
            ></b-form-input>
          </b-col>
          <b-col>
            <b-button size="sm" variant="success" @click="addVideo">
              <i class="icon-upload3 icon"></i> New Video
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <div>
      <ec2-management></ec2-management>
    </div>

    <hr />
    <div class="page__body">
      <div v-if="videoList.length">
        <div v-for="video in videoList" :key="video.id">
          <VideoTile :video="video" />
        </div>
      </div>
      <noData v-if="!videoList.length && !view.videoDataLoading"></noData>
    </div>

    <loader v-if="view.videoDataLoading"></loader>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions } = createNamespacedHelpers("admin/videosView");
import VideoTile from "../components/videos/VideoTile.vue";
import noData from "../components/NoDataAvailable.vue";
import Ec2Management from "@/module_admin/components/Ec2Management";

export default {
  data: function () {
    return {
      searchText: null,
    };
  },
  components: {
    Ec2Management,
    VideoTile,
    noData,
  },

  computed: {
    ...mapGetters(["videoList"]),

    view() {
      return this.$store.state.admin.videosView;
    },
  },

  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadVideos();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },

  mounted() {
    this.loadVideos();
  },

  methods: {
    ...mapActions(["loadVideos", "searchVideo"]),

    addVideo() {
      this.$router.push("videos/add");
    },
  },
};
</script>
